var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 20 20"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7.629 14.566a.644.644 0 00.912 0l8.219-8.221a.643.643 0 10-.911-.911l-7.764 7.763-3.933-3.93a.645.645 0 00-.911.911l4.388 4.388z","stroke":"#fff","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }